<template>
  <v-container id="help" fluid tag="section">
    <div class="mt-6">
      <v-card
        v-for="component in components"
        :key="component.id"
        class="component my-2 py-2 elevation-0"
        color="transparent"
      >
        <span
          class="component-title"
          :class="$vuetify.theme.dark ? 'white--text' : 'secondary--text'"
        >
          {{ $t(`views.help.${component.id}.title`) }}
        </span>
        <v-row>
          <v-col
            v-for="element in component.elements"
            :key="element.id"
            cols="12"
            :lg="component.id === 'filios' ? 5 : 4"
            md="6"
            xs="12"
          >
            <v-card class="element items-flex px-5 pb-4 pt-6 ma-0 elevation-0">
              <div class="element-top">
                <div class="element-title">
                  <a
                    :href="element.link"
                    target="_blank"
                    :class="$vuetify.theme.dark ? 'white--text' : 'secondary--text'"
                  >
                    <template v-if="getHelpLogo(element)">
                      <img
                        :src="getHelpLogo(element)"
                        :width="element.logoWidth ? element.logoWidth : ''"
                        :class="element.logoClass ? element.logoClass : ''"
                      />
                    </template>
                    <template v-else>
                      <span>{{ $t(`views.help.${component.id}.${element.id}.title`) }}</span>
                    </template>
                  </a>
                </div>
                <div class="element-description pt-4 pb-0">
                  {{
                    $te(`views.help.${component.id}.${element.id}.description`)
                      ? $t(`views.help.${component.id}.${element.id}.description`)
                      : ''
                  }}
                </div>
              </div>

              <div class="element-bottom mt-3">
                <a
                  :href="element.link"
                  target="_blank"
                  class="element-title"
                  @click="elementClicked(element)"
                >
                  Ir al sitio
                </a>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import gtag from '@/lib/gtag'
const helpLinks = require('@/lib/help/helpLinks.json')

export default {
  // components: {},
  // data: () => ({
  //   // loading: false,
  // }),
  computed: {
    components() {
      return helpLinks.links
    },
  },
  // watch: {},
  // async mounted() {},
  methods: {
    getHelpLogo(element) {
      try {
        if (this.$vuetify.theme.dark) {
          try {
            return require(`@/assets/help/${element.id}-dark.png`)
          } catch (error) {
            return require(`@/assets/help/${element.id}.png`)
          }
        } else {
          return require(`@/assets/help/${element.id}.png`)
        }
      } catch (error) {
        return null
      }
    },
    elementClicked(element) {
      gtag.pageview({
        pagePath: `/help/click/${element.id}`,
        pageTitle: `help|click|${element.id}`,
        pageContentGroup: 'modal',
      })
    },
  },
}
</script>

<style lang="scss">
#help {
  .items-flex {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .component {
    // background-color: #f7f8fb;
    .component-title {
      padding-left: 3px;
      font-weight: 500;
      font-size: 15px;
    }

    .element.theme--dark {
      border: 1px solid #292929;
    }

    .element {
      height: 100%;
      border: 1px solid #eeeeee;

      .element-title {
        min-height: 30px;
        img {
          max-height: 22px;
          max-width: 135px;
        }
        span {
          font-size: 18px;
          font-weight: 600;
        }
      }
      .element-description {
        font-size: 14px;
      }
      a {
        font-weight: 400 !important;
        font-size: 15px !important;
        text-decoration: none;
      }
    }
  }
}
</style>
